/**
 * ShareButton — Botão social com ícone + cor do canal
 */

interface ShareButtonProps {
  icon: string;
  label: string;
  color: string;
  onClick: () => void;
}

export function ShareButton({ icon, label, color, onClick }: ShareButtonProps) {
  return (
    <button onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px',
      borderRadius: 10, border: `1px solid ${color}30`, background: `${color}10`,
      color, fontSize: 12, fontWeight: 600, cursor: 'pointer',
      transition: 'all 0.2s',
    }}>
      <span>{icon}</span> {label}
    </button>
  );
}
